import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, DEFAULT_CURRENCY_CODE, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from '@angular/common/http';
import * as Sentry from "@sentry/angular";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuGroupPage } from './pages/menu-group-page';
import { MenuItemPage } from "./pages/menu-item-page";
import { CheckoutPage } from "./pages/checkout/checkout";
import { ChooseMethodPage } from "./pages/choose-method/choose-method";
import {CommonModule, registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { IdtagComponent } from './components/idtag/idtag.component';
import { LoadingIndicator } from './components/loading-indicator/loading-indicator';
import { AddressEntryPage } from "./pages/address-entry/address-entry";
import { OrderSuccessPage } from "./pages/order-success/order-success";
import { PaymentCancelPage } from "./pages/payment-cancel/payment-cancel";
import { PaypalCancelPage } from "./pages/paypal-cancel/paypal-cancel";
import { SearchPage } from "./pages/search/search";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppHeader } from "./components/app-header/app-header";
import { PaymentPage } from "./pages/payment/payment";
import {CheckCircle} from "./components/check-circle";
import {OpeningHoursWarning} from "./components/opening-hours-warning";
import {HomeGreeter} from "./components/home-greeter";
import {Breadcrumb} from "./components/breadcrumb";
import {NextStepButton} from "./components/next-step-button";
import {MinAmountWarning} from "./components/min-amount-warning";
import {AutofocusDirective} from "./directives/autofocus.directive";
import {ScrollTopOnFocusDirective} from "./directives/scroll-top-on-focus.directive";
import {CheckoutHeader} from "./components/checkout-header";
import {ChooseTimePage} from "./pages/choose-time/choose-time";
import {SubmitErrorPage} from "./pages/submit-error";
import {TimeZoneWarning} from "./components/time-zone-warning";
import {DiscountEntryComponent} from "./components/discount-entry";
import {DiscountBenefitComponent} from "./components/discount-benefit";
import {SelectBenefitPage} from "./pages/select-benefit";
import {MenuGroupComponent} from "./components/menu-group";
import {ItemCard} from "./components/item-card";
import {MenuItemComponent} from "./components/menu-item";
import {FlatMenuComponent} from "./components/flat-menu";
import {FlatMenuItemComponent} from "./components/flat-menu-item";
import {DiscountTimeCondition} from "./components/discount-time-condition";
import {EnterCodePage} from "./pages/enter-code";
import {VoucherEntry} from "./components/voucher-entry";
import {AppFooter} from "./components/app-footer";
import {DemoSuccessPage} from "./pages/demo-success";
import {OrderTimePipe} from "../../../common/pipes/ordertime";
import {ConstraintInfo} from "./components/constraint-info";
import {T4DCurrencyPipe} from "../../../common/pipes/currency";
import {ServiceCallButton} from "./components/service-call";
import {ServicecallSuccessPage} from "./pages/servicecall-success";
import {OptionList} from "./components/option-list";
import {MenuItemPreviewComponent} from "./components/menu-item-preview";
import {AddToCartButton} from "./components/add-to-cart-button";
import {DrawerComponent} from "./components/drawer";
import {FlatMenuBreadcrumbComponent} from "./components/flat-menu-breadcrumb";

registerLocaleData(localeDe, 'de-DE');

@NgModule({
  declarations: [
    AppComponent,
    /** pages **/
    MenuGroupPage,
    MenuItemPage,
    SearchPage,
    CheckoutPage,
    ChooseMethodPage,
    PaymentPage,
    PaymentCancelPage,
    AddressEntryPage,
    ChooseTimePage,
    OrderSuccessPage,
    DemoSuccessPage,
    PaypalCancelPage,
    SubmitErrorPage,
    SelectBenefitPage,
    EnterCodePage,
    ServicecallSuccessPage,
    /** components **/
    AddToCartButton,
    IdtagComponent,
    LoadingIndicator,
    AppHeader,
    AppFooter,
    CheckCircle,
    ConstraintInfo,
    DrawerComponent,
    OpeningHoursWarning,
    MinAmountWarning,
    HomeGreeter,
    Breadcrumb,
    NextStepButton,
    CheckoutHeader,
    DiscountBenefitComponent,
    DiscountTimeCondition,
    DiscountEntryComponent,
    VoucherEntry,
    ItemCard,
    MenuGroupComponent,
    MenuItemComponent,
    MenuItemPreviewComponent,
    FlatMenuComponent,
    FlatMenuItemComponent,
    TimeZoneWarning,
    ServiceCallButton,
    OptionList,
    FlatMenuBreadcrumbComponent,
    /** pipes **/
    OrderTimePipe,
    T4DCurrencyPipe,
    /** directives **/
    AutofocusDirective,
    ScrollTopOnFocusDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "de-DE" },
    { provide: DEFAULT_CURRENCY_CODE, useValue: "EUR" },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
